app.controller('accountExportLogPopupController', ['$rootScope', '$scope', '$state', '$mdToast', '$mdDialog', '$translate',
            'meedy.objectHelper', 'applicationModel', '$timeout', 'userModel', 'officeModel', 'exportLogEntryModel',
    function ($rootScope, $scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, $timeout,
              userModel, officeModel, exportLogEntryModel) {

        var listeners = {};

        function switchOptions() {
            if($scope.exportWholeClinic) {
                var keys = Object.keys($scope.officesIds);
                if(keys.length > 1) {
                    keys.forEach(function(key) {
                        $scope.officesIds[key] = false;
                    })
                }
                if($scope.exportLogEntry.offices) {
                    delete $scope.exportLogEntry.offices;
                }
            }
        }

        function beforeSave() {
            if(!$scope.exportWholeClinic) {
                var keys = Object.keys($scope.officesIds);
                if(!$scope.exportLogEntry.offices) {
                    $scope.exportLogEntry.offices = [];
                }
                keys.forEach(function(key) {
                    if($scope.officesIds[key]) {
                        var office = new OfficeVO()
                        office.id = parseInt(key);
                        $scope.exportLogEntry.offices.push(office);
                    }
                })
            }
        }

        function setData() {

            $scope.forms = {
                accountExportLog: null
            };

            $scope.criteria = new EsDataGridCriteria();
            $scope.offices = [];

            $scope.exportLogEntry = new ExportLogEntryVO();
            $scope.exportLogEntry.user = userModel.currentUser;
            $scope.exportLogEntry.exportType = Enum.EXPORT_TYPE.OFFICE_DATA;
            $scope.exportLogEntry.clinic = new ClinicVO(userModel.currentUser.clinicId);
            $scope.exportWholeClinic = true;
            $scope.officesIds = {}

        }

        function setPermissions() {

        }

        function setListeners() {

            $scope.$watch('exportWholeClinic', function(newVal) {
                if(newVal != undefined && newVal != null) {
                    if(newVal) {
                        switchOptions();
                    }
                }
            });

            listeners.onOfficeDataPageLoad = function(dataPage) {
                $scope.offices = dataPage.data;
                $scope.offices.forEach(function(office) {
                    $scope.officesIds[office.id] = false;
                });

                if($scope.offices.length === 1) {
                    $scope.officesIds[$scope.offices[0].id] = true;
                }

            }
        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.save = function() {
                beforeSave();
                exportLogEntryModel.save($scope.exportLogEntry).then(function(log) {
                    $mdDialog.hide(log);
                })
            }
        }

        function configureInterface() {

        }

        function initialize() {
            $scope.criteria.doctorId = userModel.currentUser.id;

            officeModel.getDataPage($scope.criteria).then(listeners.onOfficeDataPageLoad);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
